import React from 'react';
import { BigNumbersBox } from '../../../../../components/BigNumbersBox';
import { LoadingSpinerLocal } from '../../../../../components';
import styles from './BigNumbersPriceBox.module.scss';
import { formatFractionNumbers, formatNumberToCurrencyQuantityValues } from '../../utils';
import { BigNumbersIndicator } from '../BigNumbersIndicator';

type BigNumbersPriceBoxProps = {
  loading?: boolean;
  mainValue?: number | undefined;
  indicator?: number;
  firstText?: string;
  secondText?: string;
  secondValue?: number | undefined;
  type?: 'currency' | 'percent';
  styleType?: 'container' | 'up' | 'down';
};

const status = (value: string) => {
  if (value === 'up') {
    return '+';
  }
  if (value === 'down') {
    return '-';
  }
  return '';
};

export const BigNumbersPriceBox = ({
  loading,
  mainValue,
  indicator,
  firstText,
  secondText,
  secondValue,
  type,
  styleType = 'container',
}: BigNumbersPriceBoxProps) => {
  const main = Math.abs(mainValue || 0);
  const previous = Math.abs(secondValue || 0);

  return (
    <BigNumbersBox.Root height="73px" type={styleType}>
      <LoadingSpinerLocal size="sm" position="absolute" loading={loading} />
      <div className={styles['flex-center']}>
        <BigNumbersBox.MainValue>
          {`${status(styleType)}${type === 'currency' ? formatNumberToCurrencyQuantityValues(main) : `${formatFractionNumbers(main)}%`}`}
        </BigNumbersBox.MainValue>
        <BigNumbersIndicator decimal={1} indicator={indicator || 0} />
      </div>
      <BigNumbersBox.RegularText>{firstText || ''}</BigNumbersBox.RegularText>
      <div className={styles['flex-base']}>
        <BigNumbersBox.RegularText>{secondText || ''}</BigNumbersBox.RegularText>
        {secondValue ? (
          <BigNumbersBox.BoldText className={styles['bold-text-value']}>
            {type === 'currency' ? formatNumberToCurrencyQuantityValues(previous) : `${formatFractionNumbers(previous)}%`}
          </BigNumbersBox.BoldText>
        ) : null}
      </div>
    </BigNumbersBox.Root>
  );
};
